module.exports = __webpack_public_path__ + "img/ico-darek.b09840ac.svg";